/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Site_Relation_Own_DescInputs */

const en_site_relation_own_desc = /** @type {(inputs: Site_Relation_Own_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`To rebuild or modernise`)
};

const id_site_relation_own_desc = /** @type {(inputs: Site_Relation_Own_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mau dibangun ulang / dimodernkan`)
};

/**
* | output |
* | --- |
* | "To rebuild or modernise" |
*
* @param {Site_Relation_Own_DescInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const site_relation_own_desc = /** @type {((inputs?: Site_Relation_Own_DescInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Site_Relation_Own_DescInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_site_relation_own_desc(inputs)
	return en_site_relation_own_desc(inputs)
});